/* eslint-disable no-debugger */
import React from 'react';
import Loader from '@components/complex/Loader';
import styles from './styles.scss';

function DropDownList({
  border = 'none',
  changeHandler,
  condition = false,
  currentValue,
  filterFieldBg,
  isDisabled,
  label = 'Selecciona',
  name = '',
  options,
  result = false,
  user,
}) {
  return (
    <>
      {options ? (
        <select
          className={`${isDisabled ? styles.filterFieldDisabled : styles.filterField} flex1`}
          style={{
            border: '1px solid #ccc',
            borderRadius: 4,
            padding: 5,
            position: 'relative',
            minWidth: 200,
            maxWidth: 200,
            height: 35,
            fontSize: 16,
            color: '#707070',
            background: 'white',
          }}
          onChange={changeHandler}
          value={currentValue}
          disabled={isDisabled}
          name={name}
        >
          <option value="">{label}</option>
          {options.map(o => (
            <>
              <option key={o.id} value={o.value || o.id || o.idServicio}>
                {(o.title && o.title.split(' (')[0])
                  || (o.name && o.name.split(' (')[0])
                  || (o.servicio && o.servicio.split(' (')[0])}
              </option>
            </>
          ))}
        </select>
      ) : (
        <Loader />
      )
      }
    </>
  );
}

export default DropDownList;
